import { render, staticRenderFns } from "./as.vue?vue&type=template&id=5ffe315f&scoped=true&"
import script from "./as.vue?vue&type=script&lang=js&"
export * from "./as.vue?vue&type=script&lang=js&"
import style0 from "./as.vue?vue&type=style&index=0&id=5ffe315f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffe315f",
  null
  
)

export default component.exports